@let userPlan = selectedShield()?.planType ?? -1;
@let requiredPlan = item?.requiredPlan ?? -1;

@if (!isSkeleton) {
  <div
    class="bn-shield-threat-item"
    [ngClass]="{
      'bn-shield-threat-item--active': item?.isEnabled && item?.action === accessListAction.Allow,
      'bn-shield-threat-item--block': item?.isEnabled && item?.action === accessListAction.Block,
      'bn-shield-threat-item--challenge': item?.isEnabled && item?.action === accessListAction.Challenge,
      'bn-shield-threat-item--log': item?.isEnabled && item?.action === accessListAction.Log,
      'bn-shield-threat-item--bypass': item?.isEnabled && item?.action === accessListAction.Bypass,
    }">
    <div class="d-flex flex-grow align-items-start">
      <div
        class="me-2 d-flex align-items-center"
        containerClass="m-2 ms-6"
        [tooltip]="
          (showUpgradeTooltips &&
            (userPlan === PlanType.Basic && requiredPlan === PlanType.Advanced
              ? upgradeAdvancedTooltip
              : userPlan < PlanType.Business && requiredPlan === PlanType.Business
                ? upgradeBusinessTooltip
                : userPlan < PlanType.Enterprise && requiredPlan === PlanType.Enterprise
                  ? upgradeEnterpriseTooltip
                  : undefined)) ||
          undefined
        ">
        <bn-web-ui-switch
          size="sm"
          [disabled]="isInitializing() || isUpdating()"
          [loading]="isInitializing() || isUpdating()"
          [ngModel]="item?.isEnabled"
          (ngModelChange)="onSwitchClick($event)" />
      </div>
      <div>
        <div>
          <span class="text-dark-8 text-200-semi-bold">{{ item?.name }}</span>
        </div>
        <div>
          <span class="me-2 text-dark-7">
            {{ item?.entryCount | number: '1.0-0' }}
            @let isPlural = (item?.entryCount || 0) > 1;
            @switch (item?.type) {
              @case (AccessListTypeEnum.IP) {
                IP address{{ isPlural ? 'es' : '' }}
              }
              @case (AccessListTypeEnum.CIDR) {
                subnet{{ isPlural ? 's' : '' }}
              }
              @case (AccessListTypeEnum.ASN) {
                AS number{{ isPlural ? 's' : '' }}
              }
              @case (AccessListTypeEnum.Country) {
                {{ isPlural ? 'countries' : 'country' }}
              }
              @case (AccessListTypeEnum.Organization) {
                {{ isPlural ? 'organizations' : 'organization' }}
              }
              @case (AccessListTypeEnum.JA4) {
                {{ isPlural ? 'JA4 fingerprints' : 'JA4 fingerprint' }}
              }
            }
          </span>
          <span class="text-dark-6">Last updated {{ item?.lastUpdated | dateAgo }}</span>
        </div>
      </div>
    </div>
    <div
      class="d-flex"
      containerClass="m-2"
      [tooltip]="
        (showUpgradeTooltips &&
          (userPlan === PlanType.Basic && requiredPlan === PlanType.Advanced
            ? upgradeAdvancedTooltip
            : userPlan < PlanType.Business && requiredPlan === PlanType.Business
              ? upgradeBusinessTooltip
              : userPlan < PlanType.Enterprise && requiredPlan === PlanType.Enterprise
                ? upgradeEnterpriseTooltip
                : undefined)) ||
        undefined
      ">
      <ng-select
        class="bn-shield-threat-item--select ng-select-xs"
        [bindLabel]="'Name'"
        [bindValue]="'Id'"
        [clearable]="false"
        [disabled]="userPlan < requiredPlan"
        [items]="availableActions"
        [loading]="isInitializing() || isUpdating()"
        [ngModel]="item?.action"
        [searchable]="false"
        (change)="onActionSelect($event?.Id)">
        <ng-template
          let-item="item"
          ng-label-tmp>
          <span class="d-flex align-items-center">
            @switch (item?.Id) {
              @case (accessListAction.Bypass) {
                <fa-icon
                  class="me-2"
                  icon="person-to-portal" />
              }
              @case (accessListAction.Allow) {
                <fa-icon
                  class="me-2"
                  icon="circle-check" />
              }
              @case (accessListAction.Block) {
                <fa-icon
                  class="me-2"
                  icon="ban" />
              }
              @case (accessListAction.Challenge) {
                <fa-icon
                  class="me-2"
                  icon="shield-halved" />
              }
              @case (accessListAction.Log) {
                <fa-icon
                  class="me-2"
                  icon="file-lines" />
              }
              @default {
                <fa-icon
                  class="me-2"
                  icon="circle" />
              }
            }
            <span>{{ item?.Name }}</span>
          </span>
        </ng-template>

        <!-- Options template -->
        <ng-template
          let-item="item"
          ng-option-tmp>
          <span class="d-flex align-items-center">
            @switch (item?.Id) {
              @case (accessListAction.Bypass) {
                <fa-icon
                  class="me-2"
                  icon="person-to-portal" />
              }
              @case (accessListAction.Allow) {
                <fa-icon
                  class="me-2"
                  icon="circle-check" />
              }
              @case (accessListAction.Block) {
                <fa-icon
                  class="me-2"
                  icon="ban" />
              }
              @case (accessListAction.Challenge) {
                <fa-icon
                  class="me-2"
                  icon="shield-halved" />
              }
              @case (accessListAction.Log) {
                <fa-icon
                  class="me-2"
                  icon="file-lines" />
              }
              @default {
                <fa-icon
                  class="me-2"
                  icon="circle" />
              }
            }
            <span>{{ item?.Name }}</span>
          </span>
        </ng-template>
      </ng-select>

      @if (listKey === 'customLists') {
        <span class="ms-2">
          <bn-web-ui-dropdown-menu
            [items]="dropdownItems"
            [options]="{ align: 'end', size: 'sm', closeOnItemClick: true }"
            (clickAction)="onDropdownClick($event, item?.listId)">
            <span trigger>
              <button
                bn-web-ui-button
                itemStyle="stroke"
                [isSquare]="true">
                <fa-icon icon="ellipsis" />
              </button>
            </span>
          </bn-web-ui-dropdown-menu>
        </span>
      }
    </div>
  </div>
} @else {
  @for (_ of [1, 2, 3]; track _) {
    <div class="bn-shield-threat-item">
      <div class="d-flex flex-grow align-items-start">
        <div class="me-2">
          <ngx-skeleton-loader
            class="d-flex align-items-center"
            [theme]="{ 'width.px': 38, 'height.px': 20, 'margin-bottom.px': 0 }" />
        </div>
        <div>
          <div class="d-flex align-items-center">
            <span class="text-dark-8 text-200-semi-bold"><ngx-skeleton-loader [theme]="{ 'width.px': 100, 'height.px': 20, 'margin-bottom.px': -5 }" /></span>
            <ngx-skeleton-loader
              class="ms-2"
              [theme]="{ 'width.px': 70, 'height.px': 20, 'margin-bottom.px': -5 }" />
          </div>
          <div class="text-dark-7 d-flex align-items-center">
            <span class="me-2"
              ><ngx-skeleton-loader
                class=""
                [theme]="{ 'width.px': 100, 'height.px': 20, 'margin-bottom.px': -5 }"
            /></span>
            <span class="text-dark-6">
              <ngx-skeleton-loader
                class=""
                [theme]="{ 'width.px': 180, 'height.px': 20, 'margin-bottom.px': -5 }"
            /></span>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <ngx-skeleton-loader
          class="d-flex align-items-center"
          [theme]="{ 'width.px': 200, 'height.px': 32, 'margin-bottom.px': 0 }" />
        @if (listKey === 'customLists') {
          <ngx-skeleton-loader
            class="d-flex align-items-center ms-2"
            [theme]="{ 'width.px': 32, 'height.px': 32, 'margin-bottom.px': 0 }" />
        }
      </div>
    </div>
  }
}

<ng-template #upgradeAdvancedTooltip>Upgrade to Advanced plan<br />to use this feature.</ng-template>
<ng-template #upgradeBusinessTooltip>Upgrade to Business plan<br />to use this feature.</ng-template>
<ng-template #upgradeEnterpriseTooltip>Upgrade to Enterprise plan<br />to use this feature.</ng-template>
